/**
 * 九渊终端氛围层：噪点、扫描线已在 CSS，这里驱动噪点刷新与光标光晕。
 * 不接收指针，不影响战场操作。
 */

const SIZE = 128;

export function startAtmosphere(): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const canvas = document.getElementById('noise-canvas') as HTMLCanvasElement | null;
  const glow = document.querySelector('.cursor-glow') as HTMLElement | null;
  if (!canvas) return;

  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;

  const img = ctx.createImageData(SIZE, SIZE);
  let last = 0;

  const stamp = (): void => {
    const d = img.data;
    for (let i = 0; i < d.length; i += 4) {
      const v = (Math.random() * 255) | 0;
      d[i] = v;
      d[i + 1] = v;
      d[i + 2] = v;
      d[i + 3] = 40;
    }
    ctx.putImageData(img, 0, 0);
  };

  const loop = (t: number): void => {
    if (t - last > 120) {
      stamp();
      last = t;
    }
    requestAnimationFrame(loop);
  };
  stamp();
  requestAnimationFrame(loop);

  if (glow && window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener(
      'pointermove',
      (e) => {
        glow.style.setProperty('--cx', `${e.clientX}px`);
        glow.style.setProperty('--cy', `${e.clientY}px`);
      },
      { passive: true },
    );
  }
}
